import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const emptyMovement = { product_id: '', location_id: '', movement_type: 'in', quantity: '', reason: '', note: '', movement_date: new Date().toISOString().slice(0, 10) };
const emptyLimit = { product_id: '', location_id: '', min_stock_limit: 0 };

export default function Inventory() {
  const [stock, setStock] = useState([]);
  const [products, setProducts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [filterLocation, setFilterLocation] = useState('');
  const [lowOnly, setLowOnly] = useState(false);
  const [search, setSearch] = useState('');
  const [showMovementForm, setShowMovementForm] = useState(false);
  const [showLimitForm, setShowLimitForm] = useState(false);
  const [movementForm, setMovementForm] = useState(emptyMovement);
  const [limitForm, setLimitForm] = useState(emptyLimit);

  const fetchStock = async () => {
    const params = new URLSearchParams();
    if (filterLocation) params.set('location_id', filterLocation);
    if (lowOnly) params.set('low_stock_only', 'true');
    const res = await api.get('/api/inventory/stock?' + params.toString());
    setStock(res.data);
  };

  const fetchLookups = async () => {
    const [productsRes, locationsRes] = await Promise.all([
      api.get('/api/products/'),
      api.get('/api/locations/'),
    ]);
    setProducts(productsRes.data);
    setLocations(locationsRes.data);
  };

  useEffect(() => { fetchLookups(); }, []);
  useEffect(() => { fetchStock(); }, [filterLocation, lowOnly]);

  const handleMovementSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/inventory/movements', {
        ...movementForm,
        product_id: parseInt(movementForm.product_id),
        location_id: parseInt(movementForm.location_id),
        quantity: parseFloat(movementForm.quantity),
      });
      setShowMovementForm(false);
      setMovementForm(emptyMovement);
      fetchStock();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const handleLimitSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/inventory/stock/limit', {
        ...limitForm,
        product_id: parseInt(limitForm.product_id),
        location_id: parseInt(limitForm.location_id),
        min_stock_limit: parseFloat(limitForm.min_stock_limit),
      });
      setShowLimitForm(false);
      setLimitForm(emptyLimit);
      fetchStock();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const openLimitForm = (row) => {
    setLimitForm({ product_id: row.product_id, location_id: row.location_id, min_stock_limit: row.min_stock_limit });
    setShowLimitForm(true);
  };

  const q = search.trim().toLowerCase();
  const filteredStock = q
    ? stock.filter(s => (s.product_code || '').toLowerCase().includes(q) || (s.product_name || '').toLowerCase().includes(q))
    : stock;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Envanter</h2>
        <div className="flex gap-2">
          <Link to="/stock-movements" className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 font-medium text-sm">
            Hareket Geçmişi
          </Link>
          <button onClick={() => { setMovementForm(emptyMovement); setShowMovementForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium text-sm">
            + Stok Hareketi Ekle
          </button>
        </div>
      </div>

      <div className="mb-4 flex items-center gap-3">
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="🔍 Ürün kodu veya adı ara..."
          className="border rounded px-3 py-2 text-sm w-72"
        />
        <select value={filterLocation} onChange={e => setFilterLocation(e.target.value)} className="border rounded px-3 py-2 text-sm">
          <option value="">Tüm Depolar</option>
          {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
        </select>
        <label className="flex items-center gap-2 text-sm text-gray-600">
          <input type="checkbox" checked={lowOnly} onChange={e => setLowOnly(e.target.checked)} />
          Sadece düşük stoklu ürünler
        </label>
        <span className="text-sm text-gray-500 ml-auto">{filteredStock.length} kayıt</span>
      </div>

      {showMovementForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg max-h-screen overflow-y-auto">
            <h3 className="text-lg font-bold mb-4">Stok Hareketi Ekle</h3>
            <form onSubmit={handleMovementSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ürün *</label>
                  <select required value={movementForm.product_id} onChange={e => setMovementForm({...movementForm, product_id: e.target.value})} className="w-full border rounded px-3 py-2">
                    <option value="">Seçiniz</option>
                    {products.map(p => <option key={p.id} value={p.id}>{p.code} - {p.name}</option>)}
                  </select>
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Depo *</label>
                  <select required value={movementForm.location_id} onChange={e => setMovementForm({...movementForm, location_id: e.target.value})} className="w-full border rounded px-3 py-2">
                    <option value="">Seçiniz</option>
                    {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Hareket Türü *</label>
                  <select required value={movementForm.movement_type} onChange={e => setMovementForm({...movementForm, movement_type: e.target.value})} className="w-full border rounded px-3 py-2">
                    <option value="in">Giriş</option>
                    <option value="out">Çıkış</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Miktar *</label>
                  <input required type="number" step="0.01" min="0.01" value={movementForm.quantity} onChange={e => setMovementForm({...movementForm, quantity: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tarih *</label>
                  <input required type="date" value={movementForm.movement_date} onChange={e => setMovementForm({...movementForm, movement_date: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Neden</label>
                  <input value={movementForm.reason} onChange={e => setMovementForm({...movementForm, reason: e.target.value})} className="w-full border rounded px-3 py-2" placeholder="Satın alma, sevkiyat..." />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Not</label>
                  <textarea value={movementForm.note} onChange={e => setMovementForm({...movementForm, note: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowMovementForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showLimitForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-sm">
            <h3 className="text-lg font-bold mb-4">Minimum Stok Limiti</h3>
            <form onSubmit={handleLimitSubmit}>
              <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Stok Limiti *</label>
              <input required type="number" step="0.01" min="0" value={limitForm.min_stock_limit} onChange={e => setLimitForm({...limitForm, min_stock_limit: e.target.value})} className="w-full border rounded px-3 py-2" />
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowLimitForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Ürün Kodu</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Ürün Adı</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Depo</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">Miktar</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">Min. Stok Limiti</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Durum</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {filteredStock.map(s => (
              <tr key={s.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm font-mono text-gray-600">{s.product_code}</td>
                <td className="px-4 py-3 font-medium text-gray-800">{s.product_name}</td>
                <td className="px-4 py-3 text-gray-600">{s.location_name}</td>
                <td className="px-4 py-3 text-right text-gray-800">{s.quantity} {s.unit}</td>
                <td className="px-4 py-3 text-right text-gray-600">{s.min_stock_limit}</td>
                <td className="px-4 py-3">
                  {s.is_low ? (
                    <span className="bg-red-50 text-red-700 text-xs px-2 py-1 rounded font-medium">Düşük Stok</span>
                  ) : (
                    <span className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded font-medium">Normal</span>
                  )}
                </td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => openLimitForm(s)} className="text-blue-600 hover:text-blue-800 font-medium text-sm">Limit Düzenle</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredStock.length === 0 && (
          <div className="text-center py-12 text-gray-400">{stock.length === 0 ? 'Henüz stok kaydı yok' : 'Aramayla eşleşen kayıt bulunamadı'}</div>
        )}
      </div>
    </div>
  );
}
